import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs';
import { PushServiceAbs  } from './pushserviceabs';
import { Events } from 'ionic-angular';
import { Device } from '@ionic-native/device';
import { UniqueDeviceID } from '@ionic-native/unique-device-id';
import { AppVersion } from '@ionic-native/app-version';

/*
  Generated class for the FcmProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export abstract class PushServiceFcm extends PushServiceAbs {
  currentMessage = new BehaviorSubject(null);
  
    constructor(
      private angularFireMessaging: AngularFireMessaging,
      events: Events, 
      device: Device, 
      uniqueDeviceID: UniqueDeviceID, 
      appVersion: AppVersion) {
      super(events, device, uniqueDeviceID, appVersion);
      this.angularFireMessaging.messaging.subscribe(
        (_messaging) => {
          _messaging.onMessage = _messaging.onMessage.bind(_messaging);
          _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
        }
      )
    }
  
    protected initPush() {
      navigator.serviceWorker.register('sw.js').then(
        registration => {
          this.angularFireMessaging.messaging.subscribe(
            messaging => {
              try {
                messaging.useServiceWorker(registration);
              } catch(e) {
                console.debug(e)
                //caso der erro significa que já havia sido definido o sw para o firebase e não pode ser trocado depois de ter pego o token,
                //não tem um método para conferir se já foi definido ou qual está sendo usado, então o try catch foi a solução para esse caso
              };
              this.angularFireMessaging.requestToken.subscribe(
                async (token) => {
                  try {
                    await this.angularFireMessaging.deleteToken(token).toPromise().catch();
                  } catch (e) {}
                  finally {
                    this.angularFireMessaging.requestToken.subscribe(
                      (token) => {
                        this.registerOnGoPushServer(token);
                        this.receiveMessage();
                      }
                    )
                  }
                },
                (err) => {
                    console.error('Unable to get permission to notify.', err);
                }
            );
            }
          )
        }
      )
    }

    private receiveMessage() {
      navigator.serviceWorker.addEventListener('message', (event)  =>{
        this.checkMsgServer();
      });
    }

  }


// WEBPACK FOOTER //
// ./src/lib/pushservicefcm.ts